import { Button } from '@/components/Button/Button';
import { paths } from '@/routes/paths';
import styles from './NotFound.module.css';

export function NotFound() {
  return (
    <div className={styles.page}>
      <div className={styles.code}>404</div>
      <h1 className={styles.title}>We looked everywhere</h1>
      <p className={styles.copy}>
        That page isn&apos;t here. It may have sold out, moved, or never existed.
      </p>
      <Button to={paths.home}>Back to the shop →</Button>
    </div>
  );
}
